
/*
  Sticky ATC
*/
const initStickyAtc = async () => {
  const wrapper = document.querySelector('#sticky-atc')

  if (!wrapper) return

  await new Promise(resolve => setTimeout(resolve, 1000))

 const threshold = 700

  window.addEventListener('scroll', () => {
    if (window.scrollY > threshold) {
      wrapper.classList.add('show')
      document.body.style.paddingBottom = wrapper.clientHeight + 'px'
    } else {
      wrapper.classList.remove('show')
      document.body.style.paddingBottom = 0
    }
  })
}
initStickyAtc()